"use client";

import { AsideList } from "@/components/common/aside-list";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { PublicationCard } from "@/components/publication/publication-card";

export const AsideVademecumArticles = ({
  articles,
  articleId,
}: {
  articles: ArticlePreviewVM[];
  articleId: number;
}) => {
  const [opacity, setOpacity] = useState(false);

  useEffect(() => {
    const activeElement = document.querySelector(`#active-read-in-aside`);

    if (window.innerWidth > 1280) {
      activeElement?.scrollIntoView({
        behavior: "smooth",
        block: "center", // Vertical centering in the viewport
        inline: "center", // might not be needed for vertical lists
      });
    }

    setTimeout(() => {
      setOpacity(true);
    }, 1000);
  }, [articleId]);

  return (
    <div
      className={cn(
        `transition-duration-1000 transition-all`,
        opacity ? "opacity-100" : "opacity-0",
      )}
    >
      <AsideList
        items={articles.map((articlePreview) => (
          <PublicationCard
            key={articlePreview.title}
            article={articlePreview}
            isRead={articlePreview.id === articleId}
            aside={true}
          />
        ))}
      />
    </div>
  );
};
